import { forwardRef } from 'react';
import classNames from 'classnames';
import Switch from '../UI/Switch/Switch';

import './SwitchBox.scss';

type SwitchBoxProps = {
	title: string | React.ReactNode;
	caption?: string;
	onSwitch: () => void;
	checked: boolean;
	disabled?: boolean;
}

const SwitchBox = forwardRef( ( {
	title, caption = '', onSwitch, checked, disabled = false
}: SwitchBoxProps, ref: React.Ref<HTMLDivElement> ) => (
	<div className={classNames( 'SwitchBox', { disabled, checked } )} ref={ref}>
		<div>
			<h5>{title}</h5>
			<p>{caption}</p>
		</div>
		<Switch onSwitch={onSwitch} checked={checked} disabled={disabled} />
	</div>
) );

export default SwitchBox;
